import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from '@/App.vue';
import appBranding from '@/plugins/appBranding';
import messages from './global.messages.json';

const rootElement = document.getElementById('embed-assistent');
if (!rootElement) {
    throw new Error('Root element not found');
}

const { shadowRoot } = rootElement;

const app = createApp(App, {
    configurationId: rootElement?.dataset.configurationId,
});

const i18n = createI18n({
    legacy: false,
    locale: 'nl',
    fallbackLocale: 'en',
    messages,
});

app.use(i18n);
app.use(appBranding);

if (shadowRoot) {
    const appElement = shadowRoot.querySelector('div');
    const originalStyle = document.getElementById('embed-assistent-style');

    if (originalStyle) {
        const newStyle = document.createElement('style');
        newStyle.textContent = originalStyle?.textContent || '';
        shadowRoot.appendChild(newStyle);
        originalStyle?.remove();
    }

    if (appElement) {
        app.mount(appElement);
    }
} else if (rootElement) {
    app.mount(rootElement);
}
